import { useContext } from 'react'
import { ProductDetailContext } from '../context/ProductDetailContext'

export const useProductDetailContext = () => {
  const context = useContext(ProductDetailContext)
  if (!context) {
    throw new Error('useProductDetailContext must be used within ProductDetailProvider')
  }
  return context
}
